import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '@redux/store'

export interface IState {
  heThongList?: any
  heThongDetail?: any
}

const initialState: IState = {
  heThongList: {},
  heThongDetail: {},
}

export const heThongDucks = createSlice({
  name: 'heThong',
  initialState,
  reducers: {
    getListHeThong: (state: RootState, action: PayloadAction<any>) => {
      state.heThongList = { loading: true, queryStr: action.payload }
    },
    getListHeThongSuccess: (state, action: PayloadAction<any>) => {
      state.heThongList = { loading: false, ...action.payload }
    },
    getListHeThongFail: (state, action: PayloadAction<any>) => {
      state.heThongList = { loading: false, ...action.payload }
    },
    getDetailHeThong: (state: RootState, action: PayloadAction<any>) => {
      state.heThongDetail = { loading: true, id: action.payload }
    },
    getDetailHeThongSuccess: (state, action: PayloadAction<any>) => {
      state.heThongDetail = { loading: false, ...action.payload }
    },
    getDetailHeThongFail: (state, action: PayloadAction<any>) => {
      state.heThongDetail = { loading: false, ...action.payload }
    },
  },
})

export const {
  getListHeThong,
  getListHeThongSuccess,
  getListHeThongFail,
  getDetailHeThong,
  getDetailHeThongSuccess,
  getDetailHeThongFail,
} = heThongDucks.actions

export default heThongDucks.reducer 